import queryString from 'query-string'

import { apiClientChatting } from '@/utils/axios'

import type { CloneMediaJobResponse } from '../types'

const cloneMedia = (
  creatorId: number,
  mediaId: number,
): Promise<CloneMediaJobResponse> => {
  const query = queryString.stringifyUrl({
    url: `/of-chat/${creatorId}/media/clone/${mediaId}`,
  })

  return apiClientChatting.post(query.toString()).then((res) => res.data)
}

const getCloneMediaJobStatus = (
  creatorId: number,
  jobId: string,
): Promise<CloneMediaJobResponse> => {
  const query = queryString.stringifyUrl({
    url: `/of-chat/${creatorId}/media/clone/status/${jobId}`,
  })

  return apiClientChatting.get(query.toString()).then((res) => res.data)
}

export const mediaService = {
  cloneMedia,
  getCloneMediaJobStatus,
}
